import React from "react";
import Img from "gatsby-image"
import { Container } from "theme-ui";

const ArticleImage = ({ image }) => (
  <Container sx={{mb:[3,5]}} >
    <Img fluid={image.fluid} />
  </Container>
);

export default ArticleImage;
